import { render } from "./index.vue?vue&type=template&id=2ab9f597&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2ab9f597&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ab9f597"

export default script